import { useEffect, useRef } from 'react';

function useTimeout(callback: TimerHandler, delay?: number) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    let timerId: number | undefined;

    if (delay && callback && typeof callback === 'function') {
      timerId = setTimeout(callbackRef.current, delay || 0);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [callback, delay]);
}

export default useTimeout;
